export var NavSections;
(function (NavSections) {
    /** @deprecated Unused in `i301` */
    NavSections["ADMIN"] = "ADMIN";
    /** Admin version of Thing View */
    NavSections["ADMIN_VIEW"] = "ADMIN_VIEW";
    /** Simple user-configurable global rulesets */
    NavSections["ALERT_MANAGEMENT"] = "ALERTS";
    /** Area version of Thing View */
    NavSections["AREADETAIL"] = "AREADETAIL";
    /** Fetches stats from AWS CloudWatch */
    NavSections["AWSMETRICS"] = "AWSMETRICS";
    /** Hyper Users can broadcast notifications to users */
    NavSections["BROADCAST"] = "BROADCAST";
    /** Developer route for checking that calculated states are loaded properly */
    NavSections["CALCULATED_STATES"] = "CALCULATED_STATES";
    /** Compare readings from two different objects / entities */
    NavSections["COMPARISONVIEW"] = "COMPARISONVIEW";
    /** Home page / landing page / dashboard page, for use within ventures */
    NavSections["DASHBOARD"] = "DASHBOARD";
    /** Debug view for inspecting objects in the database */
    NavSections["DATATABLEVIEW"] = "DATATABLEVIEW";
    /** Something to do with adding devices? */
    NavSections["DEVICE_ACCEPTANCE"] = "DEVICE_ACCEPTANCE";
    /** Something to do with adding devices? */
    NavSections["DEVICE_ASSIGNMENT"] = "DEVICE_ASSIGNMENT";
    /** Places devices and their associated gateway(s) on a map view */
    NavSections["DEVICE_INVESTIGATION"] = "DEVICE_INVESTIGATION";
    /** Mocks payloads to a entity */
    NavSections["PAYLOAD_PARSER"] = "PAYLOAD_PARSER";
    /** a.k.a. Operations -> Network -> Device Management, shows Wideawake and database debug stats */
    NavSections["WIDEAWAKE"] = "WIDEAWAKE";
    /** Shows offline devices and gateways, and the associtated errors */
    NavSections["DEVICE_SUMMARY"] = "DEVICE_SUMMARY";
    /** a.k.a. Operations -> Devices -> Import, adds devices from a GSheet? */
    NavSections["DEVICEEUI_PROVISIONVIEW"] = "PROVISIONING";
    /** Select a single device for detailed diagnosing */
    NavSections["DIAGNOSTIC"] = "DIAGNOSTIC";
    /** Assign a gateway to a customer (or customers?) */
    NavSections["GATEWAY_ASSIGNMENT"] = "GATEWAY_ASSIGNMENT";
    /** Debug view displaying a list of gateways */
    NavSections["GATEWAY_LIST"] = "GATEWAY_LIST";
    /** Unassign a gateway (or gateways?) from a customer */
    NavSections["GATEWAY_UNASSIGNMENT"] = "GATEWAY_UNASSIGNMENT";
    /** Not an actual route, used as a key to store various things in the browser's local storage */
    NavSections["HOME"] = "HOME";
    /** Works in conjunction with `ConsumerData/IO` and `@iotv/io` to import and export objects from the database, using GSheets */
    NavSections["IMPORT_EXPORT"] = "IMPORT_EXPORT";
    /** Link devices to appropriate entities prompted from a QR code */
    NavSections["LINK_DEVICE_TO_ENTITY"] = "LINK_DEVICE_TO_ENTITY";
    /** Displays a list of entities, likely superceded by Things View */
    NavSections["LISTVIEW"] = "LISTVIEW";
    /** Handles login route */
    NavSections["LOGIN"] = "LOGIN";
    /** Developer view for GMaps demos made by RSE */
    NavSections["MAPVIEW"] = "MAPVIEW";
    /** Debug view displaying a list of networks */
    NavSections["NETWORK_LIST"] = "NETWORK_LIST";
    /** Debug view displaying gateways and devices on a GMap with associated LoRaWAN stats */
    NavSections["NETWORKCOVERAGE"] = "NETWORKCOVERAGE";
    /** Debug view displaying messages from a LoRaWAN Network Application Server */
    NavSections["NETWORKTABLEVIEW"] = "NW";
    /** Allows users to set a new password */
    NavSections["NEW_PASSWORD"] = "NEW_PASSWORD";
    /** Users who lack the `User` role don't have permission to use the app, so we presume their account to be disabled */
    NavSections["NOT_ENABLED"] = "NOT_ENABLED";
    /** Handles configuration of rulesets and notification subscriptions, displays incidents and mobile devices and notifications */
    NavSections["NOTIFICATIONS"] = "NOTIFICATIONS";
    /** Standalone screen for notification subscriptions, as users can view this screen */
    NavSections["NOTIFICATION_SUBSCRIPTIONS"] = "NOTIFICATIONSUBSCRIPTIONS";
    /** Developer route for checking that payload definitions are loaded properly */
    NavSections["PAYLOAD_DEFINITIONS"] = "PAYLOAD_DEFINITIONS";
    NavSections["PRIVACY_POLICY"] = "privacy";
    /** Developer view of the venture (project) configuration */
    NavSections["PROJECT_CONFIG"] = "PROJECT_CONFIG";
    /** @deprecated Unused in `i301` */
    NavSections["PROPERTIES"] = "PROPERTIES";
    /** @deprecated Unused in `i301` */
    NavSections["PROPERTYLIST"] = "PROPERTYLIST";
    /** @deprecated Unused in `i301` */
    NavSections["PROVISIONVIEW"] = "PROVISIONVIEW";
    /** @deprecated Unused in `i301` */
    NavSections["REDIRECT"] = "REDIRECT";
    /** @deprecated Unused in `i301` */
    NavSections["ROOT"] = "";
    /** Page where admin can set up scheduled reports for users */
    NavSections["SCHEDULEDREPORTADMIN"] = "SCHEDULEDREPORTADMIN";
    /** Page where users can manage their own reports */
    NavSections["SCHEDULEDREPORTUSER"] = "SCHEDULEDREPORTMANAGEMENT";
    /** @deprecated Unused in `i301`, likely superceded by {@link NavSections.NOTIFICATIONS} handling configuration of Rulesets */
    NavSections["RULE_MANAGEMENT"] = "RULE_MANAGEMENT";
    /** Developer view for weather, appears broken? */
    NavSections["SLOT1"] = "SLOT1";
    /** Developer view for messages, appears broken? */
    NavSections["SLOT2"] = "SLOT2";
    /** Developer view for database operations, graph queries, Wideawake, etc. */
    NavSections["SLOT3"] = "SLOT3";
    /** Developer view for auto complete search, tree filtering (currently broken),
     * gateway querying (appears broken?), AWOL incidents, LNS metrics (appears broken?),
     * gateway metrics (appears broken?), and device metrics (appears broken?)
     */
    NavSections["SLOT4"] = "SLOT4";
    /** Developer view for import/export, likely superceded by {@link NavSections.IMPORT_EXPORT} */
    NavSections["SLOTIO"] = "SLOTIO";
    /** @deprecated Unused in `i301` */
    NavSections["SYSADMIN"] = "SYSADMIN";
    /** Displays logs from S3 for various high-frequency logging Lambda's, e.g. `CalculatedState`, `ThingAlerts`
     * which are too costly to use CloudWatch
     */
    NavSections["SYSTEM_LOGS"] = "SYSTEM_LOGS";
    /** Displays records produced by SystemSelfCheck, indicating the status of core AWS processes, like network data processing */
    NavSections["SYSTEM_SELF_CHECK"] = "SYSTEM_SELF_CHECK";
    /** @deprecated Unused in `i301` */
    NavSections["TABLEVIEW"] = "TABLEVIEW";
    /** Displays a list of things from the database */
    NavSections["THINGSVIEW"] = "THINGSVIEW";
    /** Display a single thing from the database */
    NavSections["THINGVIEW"] = "THINGVIEW";
    /** Handles sign up, forgotten password, and new password routes */
    NavSections["UNAUTHENTICATED"] = "NOAUTH";
    NavSections["UNAUTHENTICATED_FORGOT"] = "NOAUTH/FORGOT";
    NavSections["UNAUTHENTICATED_SIGNUP"] = "NOAUTH/SIGNUP";
    NavSections["UNAUTHENTICATED_NEW_PASSWORD"] = "NOAUTH/NEW_PASSWORD";
    /** Displays the current user details */
    NavSections["USERVIEW"] = "USERVIEW";
    /** Developer view showing a working demo of every available UI component / widget / hook */
    NavSections["WIDGET_PLAYGROUND"] = "WIDGET_PLAYGROUND";
    NavSections["SLOT5"] = "SLOT5";
    NavSections["Integrations"] = "Integrations";
    NavSections["AWSGATEWAYS"] = "AWS_GATEWAYS";
    NavSections["SLOT6"] = "SLOT6";
})(NavSections || (NavSections = {}));
